import { IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import { IEntity, IFetchingInfo, IPaging } from "../../components/infrastructure/models";

export interface IReportTemplate extends IEntity  {
    Name: string;
    Title: string;
    GroupingColumns?: string;
    DisplayColumns: string;
    ShowCountColumn: boolean;
    DefaultFilter?: string;
}

export interface IDamageCaseReportColumn {
    key: string;
    title: string;
    name: string;
    aggregateFunc?: string;
    aggregateTitle?: string;
}

export interface IDamageCaseReportProps extends IBaseProps {
    templateId?: number;
}

export interface IDamageCaseReportStates extends IBaseStates {
    access: string[];
    defaultGroupingColumns: string[];
    defaultDisplayColumns: string[];
    defaultFilter?: any;
    columns: IDamageCaseReportColumn[];
    groupingColumns: string[];
    displayColumns: string[];
    data?: any;
    totalResultCount: number;
    resultColumns: any[];
    showCountColumn?: boolean;
    currentExecuteData?: IReportExecuteData;
    dblClicked?: boolean;
    detailsFetchingInfo?: IFetchingInfo | null;
    currentTemplate?: IReportTemplate | null;
    templateTitle?: string | null;
    defaultSearchParams: IReportDefaultSearchParam[];
}

export const aggregateFunctions: { [key: string]: { value: string; title: string; } } = {
    'Sum': { value: 'SUM({X})', title: 'جمع' },
    'Min': { value: 'MIN({X})', title: 'کوچکترین' },
    'Max': { value: 'MAX({X})', title: 'بزرگترین' },
    'Avg': { value: 'AVG({X})', title: 'میانگین' }
}

export interface IDamageCaseReportArgs {
    source: 'excel' | 'search';
    paging?: IPaging | null;
}

export interface IReportExecuteData {
    fetchingInfo: IFetchingInfo;
    groupingColumns: string[];
    displayColumns: string[];
}

export interface IReportDefaultSearchParam {
    Name: string;
    Title: string;
    Value?: any;
    Source: string;
}

export interface IReportTemplateData {
    Template?: IReportTemplate;
    Access: string[];
    DefaultSearchParams: IReportDefaultSearchParam[];
}